<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-12/12 px-4">
      <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div class="rounded-t bg-white mb-0 px-6 py-6">
          <div class="text-center flex justify-between">
            <h6 class="text-blueGray-700 text-xl font-bold">API Management Show</h6>
            <router-link
              class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              type="button" :to="'/admin/api-management/' + this.client.id + '/edit'">
              Edit
            </router-link>
          </div>
        </div>
        <div class="flex-auto px-4 lg:px-10 py-10 pt-0">

          <div class="flex flex-wrap mt-3">
            <div class="w-full lg:w-6/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                  Client Name
                </label>
                <input type="text" v-model="client.client_name" name="client_name"
                  class="border-0 px-3 py-3 text-blueGray-600 bg-blueGray-100 text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  readonly disabled />
              </div>
            </div>
            <div class="w-full lg:w-6/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                  App Name
                </label>
                <input type="text" v-model="client.app_name" name="app_name"
                  class="border-0 px-3 py-3 text-blueGray-600 bg-blueGray-100 text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  readonly disabled />
              </div>
            </div>
            <div class="w-full lg:w-6/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                  Version
                </label>
                <input type="text" v-model="client.version" name="version"
                  class="border-0 px-3 py-3 text-blueGray-600 bg-blueGray-100 text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  readonly disabled />
              </div>
            </div>
            <div class="w-full lg:w-6/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                  Intention
                </label>
                <input type="text" v-model="client.intention" name="intention"
                  class="border-0 px-3 py-3 text-blueGray-600 bg-blueGray-100 text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  readonly disabled />
              </div>
            </div>
            <div class="w-full lg:w-6/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                  Description
                </label>
                <textarea type="text" v-model="client.description" name="description"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
              </div>
            </div>
            <div class="w-full lg:w-6/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                  Parameters
                </label>
                <textarea type="text" v-model="client.query_param" name="query_param"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
              </div>
            </div>
            <div class="w-full lg:w-6/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                  Method
                </label>
                <input type="text" v-model="client.method" name="method"
                  class="border-0 px-3 py-3 text-blueGray-600 bg-blueGray-100 text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  readonly disabled />
              </div>
            </div>
            <div class="w-full lg:w-6/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                  Destination
                </label>
                <input type="text" v-model="client.destination" name="destination"
                  class="border-0 px-3 py-3 text-blueGray-600 bg-blueGray-100 text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  readonly disabled />
              </div>
            </div>

            <div class="w-full lg:w-6/12 px-4 flex mt-5">
              <div class="w-full lg:w-6/12 mb-3">
                <label class="inline-flex items-center cursor-pointer">
                  <input type="checkbox" v-model="client.is_cache_return" name="is_cache_return" disabled
                    class="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150">
                  <span class="ml-2 text-sm font-semibold text-blueGray-600"> Cache Return </span>
                </label>
              </div>
              <div class="w-full lg:w-6/12 mb-3">
                <label class="inline-flex items-center cursor-pointer">
                  <input type="checkbox" v-model="client.is_mock_api" name="is_mock_api" disabled
                    class="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150">
                  <span class="ml-2 text-sm font-semibold text-blueGray-600"> Mock API </span>
                </label>
              </div>
            </div>
            <div class="w-full lg:w-6/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                  Static Bearer
                </label>
                <textarea type="text" v-model="client.static_bearer_token_forward" name="static_bearer_token_forward"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
              </div>
            </div>

            <div class="w-full lg:w-6/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                  Mock Return
                </label>
                <textarea type="text" v-model="client.mock_return" name="mock_return"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import APIDataService from "@/services/APIDataService";

export default {
  setup() {
    const appStore = UseAppStore();
    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("api-management", "API Management", "/admin/api-management")
    return {
      appStore
    }
  },
  created() {
    this.getClient()
  },
  data() {
    return {
      client: {}
    }
  },
  components: {
  },
  methods: {
    getClient() {
      APIDataService.get(this.$route.params.id)
        .then(response => {
          console.log(response)
          this.client = response.data['data']['api_data']
        })
        .catch(e => {
          console.log(e)
        });
    },
  }
};
</script>
